// extracted by mini-css-extract-plugin
module.exports = {"main":"Signup_main__33wbs","login_form":"Signup_login_form__1FsSp","form__link":"Signup_form__link__3p0Pi"};